<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <div class="widget-heading">
          <div class="row">
            <div class="col-12 d-inline-flex align-items-center">
              <h4 class="me-3 my-0">Skierowania</h4>
            </div>
          </div>
        </div>
        <div class="widget-content">

          <div v-if="szablony && szablony.length > 0" class="col-md-4 mt-3">
            <label><strong>Wczytaj szablon:</strong></label>

            <div class="d-flex gap-2">
              <div class="position-relative flex-grow-1">
                <input type="text" class="form-control" v-model="searchSzablon" @focus="showSzablonyDropdown = true"
                  @input="filterSzablony" placeholder="Wpisz nazwę szablonu..." autocomplete="off" />

                <ul v-if="showSzablonyDropdown && filteredSzablony.length" class="list-group position-absolute w-100"
                  style="z-index: 1000; max-height: 250px; overflow-y: auto;">
                  <li v-for="s in filteredSzablony" :key="s.id" class="list-group-item list-group-item-action"
                    @click="selectSzablon(s)" style="cursor: pointer;">
                    {{ s.nazwa }}
                  </li>
                </ul>

                <div v-if="showSzablonyDropdown && searchSzablon && !filteredSzablony.length"
                  class="position-absolute w-100 bg-white border rounded p-2" style="z-index: 1000;">
                  Brak szablonów pasujących do:
                  <strong>{{ searchSzablon }}</strong>
                </div>
              </div>

              <button class="btn btn-primary" @click="loadSzablon" :disabled="!selectedSzablonId">
                Wczytaj
              </button>

              <button v-if="editingTemplateId" class="btn btn-danger" @click="deleteSzablon">
                Usuń
              </button>
            </div>
          </div>

          <div class="col-md-12 col-lg-12 mt-4">
            <div class="row">
              <div class="col-md-3 col-lg-3 mb-3">
                <label class="form-label"><strong>Data:</strong></label>
                <input type="date" class="form-control" v-model="data" />
              </div>
              <div class="col-md-3 col-lg-3 mb-3">
                <label class="form-label"><strong>Rodzaj badania lekarskiego:</strong></label>
                <select class="form-control" style="border-radius: 0;" v-model="rodzaj_badania">
                  <option value="0">Wstępne</option>
                  <option value="1">Okresowe</option>
                  <option value="2">Kontrolne</option>
                </select>
              </div>
              <div class="col-md-3 col-lg-3 mb-3">
                <label class="form-label"><strong>Rodzaj zatrudnienia:</strong></label>
                <select class="form-control" style="border-radius: 0;" v-model="rodzaj_zatrudnienia">
                  <option value="0">Zatrudniony</option>
                  <option value="1">Podejmujący</option>
                </select>
              </div>
              <div class="col-md-3 col-lg-3 mb-3">
                <label class="form-label"><strong>Imię i nazwisko pracownika:</strong></label>
                <input type="text" class="form-control" v-model="search" @input="filterUsers" />
                <ul v-if="filteredUsers.length && showDropdown" class="list-group position-absolute w-100"
                  style="z-index: 10;">
                  <li v-for="user in filteredUsers" :key="user.id" class="list-group-item list-group-item-action"
                    @click="selectUser(user)" style="cursor: pointer;">
                    {{ user.first_name }} {{ user.last_name }}
                  </li>
                </ul>
              </div>

            </div>
          </div>

          <div class="col-md-12 col-lg-12 mt-4">
            <div class="row">
              <div class="col-md-3 col-lg-3 mb-3">
                <label class="form-label"><strong>Płeć:</strong></label>
                <select class="form-control" style="border-radius: 0;" v-model="plec">
                  <option value="0">Mężczyzna</option>
                  <option value="1">Kobieta</option>
                </select>
              </div>
              <div class="col-md-3 col-lg-3 mb-3">
                <label class="form-label"><strong>Numer PESEL:</strong></label>
                <input type="text" class="form-control" v-model="pesel" />
              </div>
              <div class="col-md-3 col-lg-3 mb-3">
                <label class="form-label"><strong>Adres zamieszkania:</strong></label>
                <input type="text" class="form-control" v-model="adres_zamieszkania" />
              </div>
              <div class="col-md-3 col-lg-3 mb-3">
                <label class="form-label"><strong>Stanowisko:</strong></label>
                <input type="text" class="form-control" v-model="stanowisko" />
              </div>
            </div>
          </div>

          <div class="col-md-12 col-lg-12 mt-4">
            <textarea v-model="regula" class="form-control" rows="3" style="white-space: pre-line;"></textarea>
          </div>

          <div class="col-md-6 col-lg-6 mt-4">
            <h5>Stanowiska pracy:</h5>
            <div v-for="(rowsp, index) in rowssp" :key="index" class="d-flex gap-2 mb-2 align-items-center">
              <input v-model="rowsp.stanowiska" type="text" class="form-control">
              <button @click="addRowSP" class="btn btn-sm btn-success">+</button>
              <button v-if="rowssp.length > 1" @click="removeRowSP(index)" class="btn btn-sm btn-danger">-</button>
            </div>
          </div>


          <div class="mt-4">
            <h5>I. Czynniki fizyczne:</h5>
            <div class="d-flex gap-2 mb-1">
              <strong class="w-100">Rodzaj szkodliwości i uciążliwości na stanowisku pracy</strong>
              <strong class="w-100">Wyniki pomiarów</strong>
              <strong class="w-100">Narażenie (krotność NDN lub NDS)</strong>
            </div>
            <div v-for="(row, index) in rows" :key="index" class="d-flex gap-2 mb-2 align-items-center">
              <input v-model="row.col1" type="text" class="form-control">
              <input v-model="row.col2" type="text" class="form-control">
              <input v-model="row.col3" type="text" class="form-control">
              <button @click="addRow" class="btn btn-sm btn-success">+</button>
              <button v-if="rows.length > 1" @click="removeRow(index)" class="btn btn-sm btn-danger">-</button>
            </div>
          </div>
          <div class="mt-4">
            <h5>II. Pyły:</h5>
            <div class="d-flex gap-2 mb-1">
              <strong class="w-100">Rodzaj szkodliwości i uciążliwości na stanowisku pracy</strong>
              <strong class="w-100">Wyniki pomiarów</strong>
              <strong class="w-100">Narażenie (krotność NDN lub NDS)</strong>
            </div>
            <div v-for="(row, index) in rows2" :key="index" class="d-flex gap-2 mb-2 align-items-center">
              <input v-model="row.col1" type="text" class="form-control">
              <input v-model="row.col2" type="text" class="form-control">
              <input v-model="row.col3" type="text" class="form-control">
              <button @click="addRow2" class="btn btn-sm btn-success">+</button>
              <button v-if="rows2.length > 1" @click="removeRow2(index)" class="btn btn-sm btn-danger">-</button>
            </div>
          </div>
          <div class="mt-4">
            <h5>III. Czynniki chemiczne:</h5>
            <div class="d-flex gap-2 mb-1">
              <strong class="w-100">Rodzaj szkodliwości i uciążliwości na stanowisku pracy</strong>
              <strong class="w-100">Wyniki pomiarów</strong>
              <strong class="w-100">Narażenie (krotność NDN lub NDS)</strong>
            </div>
            <div v-for="(row, index) in rows3" :key="index" class="d-flex gap-2 mb-2 align-items-center">
              <input v-model="row.col1" type="text" class="form-control">
              <input v-model="row.col2" type="text" class="form-control">
              <input v-model="row.col3" type="text" class="form-control">
              <button @click="addRow3" class="btn btn-sm btn-success">+</button>
              <button v-if="rows3.length > 1" @click="removeRow3(index)" class="btn btn-sm btn-danger">-</button>
            </div>
          </div>
          <div class="mt-4">
            <h5>IV. Czynniki biologiczne:</h5>
            <div class="d-flex gap-2 mb-1">
              <strong class="w-100">Rodzaj szkodliwości i uciążliwości na stanowisku pracy</strong>
              <strong class="w-100">Wyniki pomiarów</strong>
              <strong class="w-100">Narażenie (krotność NDN lub NDS)</strong>
            </div>
            <div v-for="(row, index) in rows4" :key="index" class="d-flex gap-2 mb-2 align-items-center">
              <input v-model="row.col1" type="text" class="form-control">
              <input v-model="row.col2" type="text" class="form-control">
              <input v-model="row.col3" type="text" class="form-control">
              <button @click="addRow4" class="btn btn-sm btn-success">+</button>
              <button v-if="rows4.length > 1" @click="removeRow4(index)" class="btn btn-sm btn-danger">-</button>
            </div>
          </div>
          <div class="mt-4">
            <h5>V. Inne czynniki, w tym niebezpieczne:</h5>
            <div class="d-flex gap-2 mb-1">
              <strong class="w-100">Rodzaj szkodliwości i uciążliwości na stanowisku pracy</strong>
              <strong class="w-100">Wyniki pomiarów</strong>
              <strong class="w-100">Narażenie (krotność NDN lub NDS)</strong>
            </div>
            <div v-for="(row, index) in rows5" :key="index" class="d-flex gap-2 mb-2 align-items-center">
              <input v-model="row.col1" type="text" class="form-control">
              <input v-model="row.col2" type="text" class="form-control">
              <input v-model="row.col3" type="text" class="form-control">
              <button @click="addRow5" class="btn btn-sm btn-success">+</button>
              <button v-if="rows5.length > 1" @click="removeRow5(index)" class="btn btn-sm btn-danger">-</button>
            </div>
          </div>

          <div class="mt-4">
            <button @click="submitData" class="btn btn-primary mt-3 me-3">Pobierz PDF</button>
            <button v-if="!editingTemplateId" @click="showSzablonInput = true" class="btn btn-primary mt-3">Zapisz
              szablon</button>
            <button v-else @click="updateSzablon" class="btn btn-success mt-3">Aktualizuj szablon</button>
            <button v-if="editingTemplateId" @click="showNewTemplateInput = true"
              class="btn btn-secondary mt-3 ms-2">Zapisz jako nowy</button>
            <button v-if="showNewTemplateInput" @click="showNewTemplateInput = false"
              class="btn btn-danger mt-3 ms-2">Anuluj</button>
            <div v-if="showNewTemplateInput" class="mt-2 d-flex gap-2 align-items-center">
              <input v-model="nazwa_szablonu" class="form-control form-control-sm" style="max-width: 250px;"
                placeholder="Nazwa nowego szablonu">
              <button @click="saveAsNew" class="btn btn-success btn-sm">Zapisz nowy szablon</button>
            </div>
            <div v-if="showSzablonInput" class="mt-2 d-flex gap-2 align-items-center">
              <input v-model="nazwa_szablonu" class="form-control form-control-sm" style="max-width: 250px;"
                placeholder="Nazwa szablonu">
              <button @click="submitSzablon" class="btn btn-success btn-sm">Zapisz</button>
            </div>
          </div>


        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import { usePermission } from "@/composables/resources/js/composables/permissions.js";

const { hasPermission } = usePermission();

export default {
  components: { AppLayout },
  props: {
    users: Array,
  },
  data() {
    return {
      hasPermission,
      editingTemplateId: null,
      showNewTemplateInput: false,
      search: "",
      rodzaj_badania: 0,
      rodzaj_zatrudnienia: 0,
      adres_zamieszkania: "",
      plec: null,
      pesel: "",
      nazwa_szablonu: "",
      showSzablonInput: false,
      stanowisko: "",
      data: "",
      szablony: [],
      searchSzablon: "",
      filteredSzablony: [],
      showSzablonyDropdown: false,
      selectedSzablonId: null,
      modeSzablon: "new",
      regula: "Działając na podstawie art. 229 § 4a ustawy z dnia 26 czerwca 1974 r. – Kodeks pracy (Dz. U. z 2022 r. poz. 1510, z późn. zm.), kieruję na badania lekarskie:",
      filteredUsers: [],
      showDropdown: false,
      selectedUser: null,
      rowssp: [{ stanowiska: "" }],
      rows: [{ col1: "", col2: "", col3: "" }],
      rows2: [{ col1: "", col2: "", col3: "" }],
      rows3: [{ col1: "", col2: "", col3: "" }],
      rows4: [{ col1: "", col2: "", col3: "" }],
      rows5: [{ col1: "", col2: "", col3: "" }],
    };
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
    this.loadSzablony();
    if (!this.data) {
      const today = new Date().toISOString().split('T')[0];
      this.data = today;
    }
  },

  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },

  methods: {
    filterSzablony() {
      const query = this.searchSzablon.trim().toLowerCase();

      if (!query) {
        this.filteredSzablony = this.szablony;
        this.showSzablonyDropdown = true;
        return;
      }

      this.filteredSzablony = this.szablony.filter(s =>
        s.nazwa.toLowerCase().includes(query)
      );

      this.showSzablonyDropdown = true;
    },

    selectSzablon(szablon) {
      this.selectedSzablonId = szablon.id;
      this.searchSzablon = szablon.nazwa;
      this.showSzablonyDropdown = false;
    },
    loadSzablony() {
      axios.get(route('kadry.skierowania.szablony'))
        .then(res => {
          this.szablony = res.data;
          this.filteredSzablony = res.data;
        });
    },

    handleClickOutside(e) {
      if (!this.$el.contains(e.target)) {
        this.showDropdown = false;
        this.showSzablonyDropdown = false;
      }
    },
    filterUsers() {
      this.selectedUser = null;
      const query = this.search.toLowerCase();

      if (!query) {
        this.filteredUsers = [];
        this.showDropdown = false;
        return;
      }

      this.filteredUsers = this.users.filter(user => {
        const fullName = `${user.first_name} ${user.last_name}`.toLowerCase();
        return fullName.includes(query);
      });

      this.showDropdown = true;
    },

    selectUser(user) {
      this.search = `${user.first_name} ${user.last_name}`;
      this.selectedUser = user;
      this.showDropdown = false;
      axios.get(route('kadry.skierowania.get_adres_zamieszkania', user.id))
        .then(res => {
          this.adres_zamieszkania = res.data.adres_zamieszkania;
          this.plec = res.data.plec;
          this.stanowisko = res.data.position;
        })
        .catch(err => {
          console.error(err);
        });
    },

    addRowSP() {
      this.rowssp.push({
        stanowiska: ""
      });
    },

    addRow() {
      this.rows.push({
        col1: "",
        col2: "",
        col3: ""
      });
    },
    addRow2() {
      this.rows2.push({
        col1: "",
        col2: "",
        col3: ""
      });
    },
    addRow3() {
      this.rows3.push({
        col1: "",
        col2: "",
        col3: ""
      });
    },
    addRow4() {
      this.rows4.push({
        col1: "",
        col2: "",
        col3: ""
      });
    },
    addRow5() {
      this.rows5.push({
        col1: "",
        col2: "",
        col3: ""
      });
    },

    removeRowSP(index) {
      this.rowssp.splice(index, 1);
    },

    removeRow(index) {
      this.rows.splice(index, 1);
    },
    removeRow2(index) {
      this.rows2.splice(index, 1);
    },
    removeRow3(index) {
      this.rows3.splice(index, 1);
    },
    removeRow4(index) {
      this.rows4.splice(index, 1);
    },
    removeRow5(index) {
      this.rows5.splice(index, 1);
    },
    submitData() {
      const payload = {
        user: this.selectedUser,
        text: this.search,
        rodzaj_badania: this.rodzaj_badania,
        rodzaj_zatrudnienia: this.rodzaj_zatrudnienia,
        data: this.data,
        regula: this.regula,
        stanowisko: this.stanowisko,
        stanowiska: this.rowssp,
        pesel: this.pesel,
        adres: this.adres_zamieszkania,
        plec: this.plec,
        dane1: this.rows,
        dane2: this.rows2,
        dane3: this.rows3,
        dane4: this.rows4,
        dane5: this.rows5
      };

      axios.post(route('kadry.skierowania.drukuj'), payload, {
        responseType: 'blob'
      }).then(res => {
        const fileURL = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = fileURL;
        link.setAttribute('download', 'Skierowanie.pdf');
        document.body.appendChild(link);
        link.click();
      });
    },

    submitSzablon() {
      const payload = {
        nazwa: this.nazwa_szablonu,
        regula: this.regula,
        stanowiska: this.rowssp,
        dane1: this.rows,
        dane2: this.rows2,
        dane3: this.rows3,
        dane4: this.rows4,
        dane5: this.rows5
      };

      axios.post(route('kadry.skierowania.save_szablon'), payload)
        .then(() => {
          this.showToast('success', 'Zapisano', 'Szablon został zapisany.');
          this.showSzablonInput = false;
          this.nazwa_szablonu = "";
          this.loadSzablony();
        })
        .catch(err => {
          this.showToast('error', 'Błąd', 'Nie udało się zapisać szablonu.');
          console.error(err);
        });
    },
    loadSzablon() {
      if (!this.selectedSzablonId) return;

      axios.get(route('kadry.skierowania.szablon', this.selectedSzablonId))
        .then(res => {
          const s = res.data.szablon;
          this.editingTemplateId = s.id;
          this.showNewTemplateInput = false;
          this.regula = s.regula;
          this.nazwa_szablonu = s.nazwa || "";
          this.rows = [];
          this.rows2 = [];
          this.rows3 = [];
          this.rows4 = [];
          this.rows5 = [];
          this.rowssp = [];

          s.dane.forEach(d => {
            const row = {
              col1: d.dane_1,
              col2: d.dane_2,
              col3: d.dane_3,
            };

            if (d.data_typ == 1) this.rows.push(row);
            if (d.data_typ == 2) this.rows2.push(row);
            if (d.data_typ == 3) this.rows3.push(row);
            if (d.data_typ == 4) this.rows4.push(row);
            if (d.data_typ == 5) this.rows5.push(row);
            if (d.data_typ == 6) this.rowssp.push({ stanowiska: d.dane_1 });
          });
        });
    },
    deleteSzablon() {
      if (!this.selectedSzablonId) return;

      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie szablonu',
        html: 'Czy na pewno chcesz usunąć wybrany szablon?',
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
        timer: false,
        position: 'center'
      }).then((result) => {
        if (result.isConfirmed) {

          axios.delete(route('kadry.skierowania.delete_szablon', this.selectedSzablonId))
            .then(() => {
              this.selectedSzablonId = null;
              this.editingTemplateId = null;
              this.loadSzablony();

              this.showToast('success', 'Usunięto', 'Szablon został usunięty.');
            })
            .catch(err => {
              console.error(err);
              this.showToast('error', 'Błąd', 'Nie udało się usunąć szablonu.');
            });

        }
      });
    },
    updateSzablon() {
      if (!this.editingTemplateId) return;
      const payload = this.buildPayload();
      payload.nazwa = this.nazwa_szablonu;
      axios.post(
        route('kadry.skierowania.update_szablon', this.editingTemplateId),
        payload
      )
        .then(() => {
          this.showToast('success', 'Zaktualizowano', 'Szablon został zaktualizowany.');

          this.loadSzablony();
        })
        .catch(err => {
          this.showToast('error', 'Błąd', 'Nie udało się zaktualizować szablonu.');
          console.error(err);
        });
    },
    saveAsNew() {
      const payload = this.buildPayload();
      payload.nazwa = this.nazwa_szablonu;
      axios.post(route('kadry.skierowania.save_szablon'), payload)
        .then(() => {
          this.showToast('success', 'Zapisano', 'Zapisano jako nowy szablon.');
          this.nazwa_szablonu = "";
          this.showNewTemplateInput = false;

          this.editingTemplateId = null;
          this.loadSzablony();
        })
        .catch(err => {
          this.showToast('error', 'Błąd', 'Nie udało się zapisać jako nowy szablon.');
          console.error(err);
        });
    },
    buildPayload() {
      return {
        nazwa: this.nazwa_szablonu,
        regula: this.regula,
        stanowiska: this.rowssp,
        dane1: this.rows,
        dane2: this.rows2,
        dane3: this.rows3,
        dane4: this.rows4,
        dane5: this.rows5
      };
    },
    showToast(icon, title, message) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: icon,
        title: title,
        html: message,
        showClass: { popup: 'animate__animated animate__fadeInDown' },
        hideClass: { popup: 'animate__animated animate__fadeOutUp' },
        timer: 1500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    }
  }
};
</script>
